import React from "react";
import AddIcon from "../../components/Icons/AddIcon";
import SuccessIcon from "../../components/Icons/SuccessIcon";
import UIButton from "../../../../../globalComponents/UIComponents/UIButton";

import "./style.scss";
import "../../styles.scss";

const UploadPhotoField = ({
    $locale,
    required = false,
    disabled = false,
    isPhotoUpload,
    onOpenEditor,
    onView,
}) => {
    return (
        <div className={`upload-photo-field ${required ? 'required' : ''}`}>
            {!isPhotoUpload
                ? <UIButton
                    style="upload-photo-button add-photo"
                    disabled={disabled}
                    onClick={onOpenEditor}
                >
                    <AddIcon />
                    {$locale.get('registration.field.addPhoto')}
                </UIButton>
                : <div className="upload-photo-field__block">
                    <div>
                        <SuccessIcon />
                        <p>{$locale.get('registration.field.photoAdded')}</p>
                    </div>
                    <UIButton
                        style="upload-photo-button"
                        onClick={() => {
                            onView();
                            onOpenEditor();
                        }}
                    >
                        {$locale.get('button.look')}
                    </UIButton>
                </div>
            }
        </div>
    );
};

export default UploadPhotoField;
